<template>
  <div class="box5-container">
    <div class="left_num">
      <div class="num_one">{{itemData.total}}<span>{{$t("home.box5.text1")}}</span></div>
      <div class="num_one">{{itemData.program}}<span>{{$t("home.box5.text2")}}</span></div>
    </div>
    <div class="right_video">
      <div v-if="itemData.url" class="video">
        <template  v-if="itemData.type==2">
          <el-carousel trigger="click" class="carousel-ad" height="160px">
            <el-carousel-item v-for="item in checkImg(itemData.url)" :key="item">
              <img :src="item"/>
            </el-carousel-item>
          </el-carousel>
        </template>
        <template  v-else>
        <video
          :src="itemData.url"
          controls
          loop
          autoplay
          width="100%"
          height="100%"
        ></video>
        </template>
      </div>
      <div class="no_video" v-else>{{$t("home.box5.text3")}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Box5', 
  props: {
    itemData: {
      type: Object,
      required: true,
      default: function () {
        return {
          total: 0,
          program: 0,
          url: []
        }
      }
    }
  },
  data() {
    return {
    }
  },
  methods: {
    checkImg(value) {
      if (Array.isArray(value)) {
        return  value
      } else if (typeof value === 'string') {
        return [value]
      } else {
        return []
      }
    }
  }
}
</script>
<style lang='less'>
.box5-container {
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  display:flex;
  padding: 10px;
  .left_num{
    height:100%;
    width:125px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top:-5px;
    .num_one{
      color:#1de7ff;
      font-size: 28px;
      font-family: Bahnschrift, Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
      font-style: normal;
      text-align: center;
      margin-top:10px;
      span{
        margin-top:2px;
        display:block;
        color:#fff;
        font-size: 12px;
        font-family: Arial;
      }
    }
  }
  .right_video{
    left:10px;
    right: 30px;
    top:0;
    bottom:20px;
    position: absolute;
    padding-left: 125px;;
    .video{
      width:100%;
      height:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #000;
      overflow: hidden;
      video{
        height:100%;
        width:100%;
        object-fit:fill
      }
      img{
        height:100%;
        width:auto;
      }
    }
    .no_video{
      height:100%;
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size:18px;
      color:#fff;
      background: #3f3a32;
    }
  }
  .carousel-ad{
    width: 100%;
    height: 100%;
    .el-carousel__container{
      .el-carousel__item{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        img{
          width: auto;
          height: 100%;
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
    .el-carousel__button{
      width: 5px;
      height: 5px;
      border-radius: 5px;
    }
  }
}
</style>
